/**
 * @description: 意见管理报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="or-hf-report">
        <div class="yg-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ygTime">
                        <input type="text" class="form-control laydate-icon" v-model="ygStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ygEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="yg_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-2">区域:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择区域" ref="yg_area"></select>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢号" ref="yg_box"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">处理状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择处理状态" ref="yg_deal">
                        <option value=" ">全部</option>
                        <option value="1">已处理</option>
                        <option value="-1">未处理</option>
                    </select>
                </div>
                <div class="col-md-1 ct-col yg-tit-sel">
                    <select class="form-control" ref="yg_tit_sel">
                        <option value="ahead_user_name">用户微信昵称</option>
                        <option value="reply_user_name">操作员工姓名</option>
                        <option value="work_number">操作员工工号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="yg_con_val" :placeholder="yg_con_phd">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYgTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYgExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ygList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ygExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ygExport_allcheck' @click='ygExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="room_area_name">
                            <label>区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="ahead_user_name">
                            <label>用户微信昵称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="opinion_text">
                            <label>提交内容</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="create_time">
                            <label>提交时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="reply_time">
                            <label>处理时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="reply_user_name">
                            <label>操作员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="reply">
                            <label>处理内容</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ygExport_checkModel' value="status_name">
                            <label>处理状态</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ygExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ygExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ygStartTime: "",
                ygEndTime: "",
                yg_field: "ahead_user_name",
                yg_con_phd: "请输入用户微信昵称",
                yg_con_val: "",
                ygExport_allcheck: false,
                c_ygExport_allcheck: false,
                ygExport_checkModel: [],
                ygExport_checkData: ['shop_name', 'room_area_name', 'room_name', 'ahead_user_name', 'opinion_text', 'create_time', 'reply_time', 'reply_user_name', 'reply', 'status_name'],
                ygExport_type: 1,
            }
        },
        watch: {
            ygExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ygExport_checkModel.length >= this.ygExport_checkData.length) {
                        this.ygExport_allcheck = true;
                        this.c_ygExport_allcheck = true;
                    } else {
                        this.ygExport_allcheck = false;
                        this.c_ygExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.ygStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.ygEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 处理状态
            $(_this.$refs.yg_deal).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
            // 下拉选项
            $(_this.$refs.yg_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.yg_field = $(this).val();
                if(_this.yg_field == 'ahead_user_name') {
                    _this.yg_con_phd = '请输入用户微信昵称';
                } else if(_this.yg_field == 'reply_user_name') {
                    _this.yg_con_phd = '请输入操作员工姓名';
                } else if(_this.yg_field == 'work_number') {
                    _this.yg_con_phd = '请输入操作员工工号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ygStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ygEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ygStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ygEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ygTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ygStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.ygEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.yg_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    // 区域
                                    $(_this.$refs.yg_area).val('').trigger('change');
                                    $(_this.$refs.yg_area).prop('disabled', true);
                                    // 包厢号
                                    $(_this.$refs.yg_box).val('').trigger('change');
                                    $(_this.$refs.yg_box).prop('disabled', true);
                                    return;
                                }
                                // 区域
                                $(_this.$refs.yg_area).val('').trigger('change');
                                $(_this.$refs.yg_area).prop('disabled', false);
                                _this.getRoomArea(e.params.data.id);
                                // 包厢号
                                $(_this.$refs.yg_box).val('').trigger('change');
                                $(_this.$refs.yg_box).prop('disabled', false);
                                _this.getRoomdata(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.yg_shop).val(data.response.result[1].id).trigger('change');
                            // 区域
                            $(_this.$refs.yg_area).val('').trigger('change');
                            $(_this.$refs.yg_area).prop('disabled', false);
                            _this.getRoomArea($(_this.$refs.yg_shop).val());
                            // 包厢号
                            $(_this.$refs.yg_box).val('').trigger('change');
                            $(_this.$refs.yg_box).prop('disabled', false);
                            _this.getRoomdata($(_this.$refs.yg_shop).val());
                            _this.setShopDefaultTime($(_this.$refs.yg_shop).val());
                            _this.innitYgTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{id: ' ', text: '全部'}];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.yg_area).html("");
                            $(_this.$refs.yg_area).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: "100%"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.yg_box).html("");
                            $(_this.$refs.yg_box).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },



            // 表格
            innitYgTable: function() {
                let _this = this;
                $(_this.$refs.ygList).bootstrapTable('destroy');
                $(_this.$refs.ygList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYgList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "room_area_name",
                        title: "区域",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "ahead_user_name",
                        title: "用户<br />微信昵称",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "opinion_text",
                        title: "提交内容",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "create_time",
                        title: "提交时间",
                        width: "100",
                        valign: "middle"
                    }, {
                        field: "reply_time",
                        title: "处理时间",
                        width: "100",
                        valign: "middle"
                    }, {
                        field: "reply_user_name",
                        title: "操作员工",
                        width: "9%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value + '('+ row.work_number +')'
                        }
                    }, {
                        field: "reply",
                        title: "处理内容",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "status_name",
                        title: "处理状态",
                        width: "9%",
                        valign: "middle"
                    }],
                });
            },
            getYgList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let ahead_user_name = '',
                    reply_user_name = '',
                    work_number = '';
                if(_this.yg_field == 'ahead_user_name') {
                    ahead_user_name = _this.yg_con_val;
                } else if(_this.yg_field == 'reply_user_name') {
                    reply_user_name = _this.yg_con_val;
                } else if(_this.yg_field == 'work_number') {
                    work_number = _this.yg_con_val;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ygStartTime,
                            "end_time": _this.ygEndTime,
                            "shop_id": $(_this.$refs.yg_shop).val(),
                            "room_area": $.trim($(_this.$refs.yg_area).val()),
                            "room_id": $.trim($(_this.$refs.yg_box).val()),
                            "status": $.trim($(_this.$refs.yg_deal).val()),
                            "ahead_user_name": ahead_user_name,
                            "reply_user_name": reply_user_name,
                            "work_number": work_number
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getUsersOpinionsList',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYgExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/userOpinionsExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ygExport_checkModel = data.response.result.export_fields;
                                _this.ygExport_type = data.response.result.export_type;
                            } else {
                                _this.ygExport_checkModel = _this.ygExport_checkData;
                                _this.ygExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ygExport_alert)
                }, function() {
                    _this.exportYgList();
                });
            },
            // 导出字段全选
            ygExportCheckedAll: function(type) {
                let _this = this;
                _this.ygExport_allcheck = _this.c_ygExport_allcheck;
                if(!_this.ygExport_allcheck) { // 实现全选
                    _this.ygExport_checkModel = [];
                    _this.ygExport_checkData.forEach(function(item) {
                        _this.ygExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ygExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportYgList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.ygExport_checkModel);
                let ahead_user_name = '',
                    reply_user_name = '',
                    work_number = '';
                if(_this.yg_field == 'ahead_user_name') {
                    ahead_user_name = _this.yg_con_val;
                } else if(_this.yg_field == 'reply_user_name') {
                    reply_user_name = _this.yg_con_val;
                } else if(_this.yg_field == 'work_number') {
                    work_number = _this.yg_con_val;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/userOpinionsExport" +
                    "?start_time=" + _this.ygStartTime +
                    "&end_time=" + _this.ygEndTime +
                    "&shop_id=" + $(_this.$refs.yg_shop).val() +
                    "&room_area=" + $.trim($(_this.$refs.yg_area).val()) +
                    "&room_id=" + $.trim($(_this.$refs.yg_box).val()) +
                    "&status=" + $.trim($(_this.$refs.yg_deal).val()) +
                    "&ahead_user_name=" + ahead_user_name +
                    "&reply_user_name=" + reply_user_name +
                    "&work_number=" + work_number +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ygExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .yg-list {
        .yg-tit-sel {
            width: 125px;
            padding: 0;
        }
    }
</style>